import type { AppNotification } from '@/features/notifications/api';

import { NotificationItem } from './NotificationItem';
import { PanelSectionHeader } from './PanelSectionHeader';

/**
 * Bloque de la campanita para filas de core.notifications. Reusable por sección:
 * "Asignaciones" (respuestas a asignaciones + pendientes estancadas) y "Mensajes"
 * (DMs de chat). Extraído de NotificationBell para no pasar el límite de tamaño.
 */
export function NotificationsSection({
  notifications,
  onMarkAllRead,
  onActivate,
  title = 'Asignaciones',
}: {
  notifications: AppNotification[];
  /** Si no se pasa, no se muestra el botón "marcar leído". */
  onMarkAllRead?: () => void;
  onActivate: (id: string) => void;
  title?: string;
}) {
  if (notifications.length === 0) return null;
  return (
    <div>
      <PanelSectionHeader
        title={title}
        aside={
          onMarkAllRead && (
            <button
              type="button"
              onClick={onMarkAllRead}
              className="text-fg-muted hover:text-fg transition-colors"
            >
              Marcar leído
            </button>
          )
        }
      />
      <ul>
        {notifications.slice(0, 6).map((n) => (
          <NotificationItem key={n.id} notification={n} onActivate={() => onActivate(n.id)} />
        ))}
      </ul>
    </div>
  );
}
